import React, { FC } from 'react';
import { Translate, TranslateScope } from '@pegasus/translation';
import { TitlePreset } from '@lux/title';
import { ButtonType } from '@lux/buttons';
import { track } from '@client/helpers/tracking';
import { useDispatch, useSelector } from 'react-redux';
import { getCampaignFilterTag, updateFilterTags } from '@client/redux/modules/mylounge';
import * as S from './campaign-filters.styles';
import { CampaignFilterTags } from '../banner/constants';

type CampaignFiltersProps = {};

const trackCampaign = (key: string) => {
    track(key, {
        component: 'Campaign Overview',
    });
};

const CampaignFilters: FC<CampaignFiltersProps> = () => {
    const dispatch = useDispatch();

    const selectedFilter = useSelector(getCampaignFilterTag);

    const setselectedFilter = (filter: CampaignFilterTags) => {
        if (filter === CampaignFilterTags.ALL) {
            trackCampaign('campaignFreshness_All');
        } else if (filter === CampaignFilterTags.STARTING_TODAY) {
            trackCampaign('campaignFreshness_startedToday');
        } else if (filter === CampaignFilterTags.ENDING_TODAY) {
            trackCampaign('campaignFreshness_endingToday');
        }

        dispatch(updateFilterTags(filter));
    };

    return (
        <TranslateScope path="filters">
            <S.CrossCampaignContainer>
                <S.StyledTitle preset={TitlePreset.XS}>
                    <Translate message="title" />
                </S.StyledTitle>
                <S.Container>
                    <S.StyledButton
                        buttonType={ButtonType.secondary}
                        selected={selectedFilter === CampaignFilterTags.ALL}
                        onClick={() => setselectedFilter(CampaignFilterTags.ALL)}
                    >
                        <Translate message="actionAll" />
                    </S.StyledButton>
                    <S.StyledButton
                        buttonType={ButtonType.secondary}
                        selected={selectedFilter === CampaignFilterTags.STARTING_TODAY}
                        onClick={() => setselectedFilter(CampaignFilterTags.STARTING_TODAY)}
                    >
                        <Translate message="actionStarted" />
                    </S.StyledButton>
                    <S.StyledButton
                        buttonType={ButtonType.secondary}
                        selected={selectedFilter === CampaignFilterTags.ENDING_TODAY}
                        onClick={() => setselectedFilter(CampaignFilterTags.ENDING_TODAY)}
                    >
                        <Translate message="actionEnded" />
                    </S.StyledButton>
                </S.Container>
            </S.CrossCampaignContainer>
        </TranslateScope>
    );
};

export { CampaignFilters };
